<template>
  <div class="d-flex justify-content-center p-4">
    <div class="spinner spinner-primary"></div>
  </div>
</template>

<script>
export default {
  name: "InlineLoader"
};
</script>
